<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    沙头角站<br>
站点介绍<br>
沙头角站位于盐田区深盐路和沙深路、园林路交叉口处，沿深盐路东西向敷设，西接梧桐山南站，东接海山站。 沙头角站是8号线一期的车站，为特色车站，站点元素通过提取沙头角非物质文化遗产的“鱼灯文化”进行设计优化，中间造型提取“鱼灯”的文化元素，两侧以标准模块将天花管道弱化处理。车站结构为地下两层形式，地下一层为站厅层，地下二层为站台层，站台为岛式站台。车站共有4个出入口，出入口主要临近梧桐山隧道口公交站、盐田公交派出所、沙头角消防中队等。周边有沙头角口岸、中英街等购物点。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:00	23:20	8号线	5分10秒	5分45秒<br>
盐田路	06:41	00:20	8号线	5分10秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:02	23:20	8号线	4分钟	5分钟<br>
盐田路	06:41	00:20	8号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:02	00:10	8号线	4分钟	5分钟<br>
盐田路	06:41	01:20	8号线	4分钟	5分钟<br><br>

站点出口信息<br>
A1出入口:<br>
深盐路南侧（西）、盐田区福利中心、盐田区老人颐养院<br><br>
A2出入口:<br>
深盐路北侧（西）、沙头角社区居委会、沙头角社康<br><br>
B出入口:<br>
深盐路南侧（东）、沙头角街道文化站、沙头角行政服务大厅、沙头角派出所、田心社区居委会、沙头角海关、蓝郡公馆、沙深路（北）-中英街<br><br>
C出入口:
深盐路北侧（东）、园林路东侧<br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 沙头角地铁站<br>
308、M314、M520、M191、M205、M199、M437<br><br>
A1出入口:<br>
公交站名： 沙头角地铁站A1出入口（招呼站）<br>
B662、B662区间线<br><br>
A2出入口:<br>
公交站名： 沙头角地铁站<br>
308、M520、M191、M205、M199、M437、M314<br><br>
C出入口:<br>
公交站名： 沙头角地铁站C出入口（招呼站）<br>
B662区间线<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "bahaoxian",
          title: "8号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>